import React, { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

const HIGHLIGHT_BEGIN_TAG = '<em>';
const HIGHLIGHT_END_TAG = '</em>';

const parseHighlight = (highlight: string) => {
  const chunks = highlight.split(HIGHLIGHT_BEGIN_TAG);

  const parsedHighlight = [];
  for (const chunk of chunks) {
    const endTagIndex = chunk.indexOf(HIGHLIGHT_END_TAG);

    if (endTagIndex === -1) {
      parsedHighlight.push({ highlight: false, text: chunk });
    } else {
      parsedHighlight.push({ highlight: true, text: chunk.substring(0, endTagIndex) });
      parsedHighlight.push({
        highlight: false,
        text: chunk.substring(endTagIndex + HIGHLIGHT_END_TAG.length),
      });
    }
  }

  return parsedHighlight;
};

type ResumeHighlightedSectionProps = {
  highlights: string[];
};
export const ResumeHighlightedSection = ({ highlights }: ResumeHighlightedSectionProps) => {
  const parsedHighlights = useMemo(
    () => highlights.map(highlight => parseHighlight(highlight)),
    [highlights],
  );

  return (
    <div className="flex flex-col whitespace-normal overflow-scroll max-h-32">
      {parsedHighlights.map((parsedHighlight, index) => (
        <div key={`highlight-${index}`}>
          {parsedHighlight.map((text, index) => (
            <span
              key={`higlight-chunk-${index}`}
              className={twMerge(text.highlight && 'font-bold')}
            >
              {text.text}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
};
